import React from "react";
import Header from "../../components/header/Header";
import MainDiv from "./style";

const Home = () => {
  return (
    <MainDiv>
      <Header />
    </MainDiv>
  );
};

export default Home;
